var MenuTabletMango = $.extend({/* MenuTabletMango */}, BaseComponent, {

	componentSelector: '.dropdown-menu-trigger',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).click((function(event) {
			if ($(event.currentTarget).parents('header').siblings('nav').find('.navigation-tablet').hasClass('active')) {
				$(event.currentTarget).parents('header').siblings('nav').find('.navigation-tablet').removeClass('active');
			}
			else {
				$(event.currentTarget).parents('header').siblings('nav').find('.navigation-tablet').addClass('active');
			}			
		}).bind(this));

		$(this.componentSelector).parents('header').siblings('nav').find('.navigation-tablet').mouseleave((function(event) {
			$(event.currentTarget).removeClass('active');
		}).bind(this));		
	}	
})